

import React, { useContext } from "react";
import ProductCard from "../components/Product/ProductCard";
import products, { giftProducts } from "../data/product.js";
import ProductFilter from "../components/Product/ProductFilter";
import { LanguageContext } from "../context/LanguageContext";

export default function Category() {
  const { language } = useContext(LanguageContext);
  const text = {
    tr: { products: "Ürünler", gifts: "Hediyeler" },
    en: { products: "Products", gifts: "Gifts" },
  };
  return (
    <div>
      {/* ÜRÜNLER */}
      <div className="product-card-header text-center mt-5">
        <h2>{text[language].products}</h2>
      </div>
      <ProductFilter />

      {/* HEDİYELER */}
      <div className="product-card-header text-center mt-5">
        <h2>{text[language].gifts}</h2>
      </div>
      <div className="container py-4">
        <div className="row g-4">
          {giftProducts.map((giftProducts) => (
            <div
              key={giftProducts.id}
              className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex"
            >
              <ProductCard product={giftProducts} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
